import { createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7dc9d025"), n = n(), _popScopeId(), n);
const _hoisted_1 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "system-item"
}, [/*#__PURE__*/_createElementVNode("ul", null, [/*#__PURE__*/_createElementVNode("li", null, [/*#__PURE__*/_createElementVNode("div", {
  class: "system_head"
}, [/*#__PURE__*/_createElementVNode("p", null, "系统"), /*#__PURE__*/_createElementVNode("span", null, "2022-10-30 17:59:56")]), /*#__PURE__*/_createElementVNode("div", {
  class: "system_cont"
}, [/*#__PURE__*/_createElementVNode("p", null, "快乐8升级成功，请大家下载APP ！记住赚钱网址：69tk.com")])])])], -1));
import nav_header from '@/components/nav_header.vue';

import { onBeforeMount } from 'vue';
export default {
  __name: 'stationNews',
  setup(__props) {
    onBeforeMount(() => {
      let public_conf = JSON.parse(localStorage.getItem('public_conf'));
      console.log(public_conf);
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(nav_header, {
        name: "站内消息"
      }), _hoisted_1], 64);
    };
  }
};